import { PickupDashboardApiRepository } from "@/app/infrastructures/repositories/api/PickupDashboardApiRepository";
import { ExportApiRequest } from "@/data/payload/api/PickupDashboardApiRequest";
import { DexAssessmentList } from "@/domain/entities/DexAssessment";
import { injectable } from "tsyringe";
import { CourierPickupSummary, AvailableCourierList, TransferPickupRequest, CourierPickupShipment, SenderList, TransferPickupListRequest, ManualAssignResponse } from "@/domain/entities/PickupDashboard";
import { CourierSummaryRequest, ShipmentListRequest, PickupShipmentRequest, CourierListRequest, ManualAssignRequest } from "@/data/payload/api/PickupDashboardRequests";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { RequestListSummary, RequestTabsList, TabsList } from "@/domain/entities/PickupDashboardSummary";

@injectable()
export class PickupDashboardPresenter {
  private repository: PickupDashboardApiRepository;

  constructor(repository: PickupDashboardApiRepository) {
    this.repository = repository;
  }

  public geTabsList(params: RequestTabsList): Promise<TabsList> {
    return this.repository.getTabsList(params)
  }

  public getListSummary(params: RequestListSummary) {
    return this.repository.getListSummary(params)
  }

  public export(payload: ExportApiRequest): Promise<DexAssessmentList> {
    return this.repository.export(payload);
  }
  public getCourierSummary(
    params: CourierSummaryRequest
  ): Promise<CourierPickupSummary> {
    return this.repository.getCourierSummary(params);
  }

  public getShipmentList(
    params: ShipmentListRequest
  ): Promise<ResponsePayloadV2> {
    return this.repository.getShipmentList(params);
  }

  public getAvailableCouriers(taskGroupIds?: string, q?: string): Promise<AvailableCourierList> {
    return this.repository.getAvailableCouriers(taskGroupIds, q);
  }

  public transferPickup(payload: TransferPickupRequest): Promise<any> {
    return this.repository.transferPickup(payload);
  }

  public getSenderList(params: TransferPickupListRequest): Promise<SenderList> {
    return this.repository.getSenderList(params);
  }

  public getBookingEligibleShipments(
    params: PickupShipmentRequest
  ): Promise<CourierPickupShipment> {
    return this.repository.getBookingEligibleShipments(params);
  }

  public getCourierList(
    params: CourierListRequest
  ) {
    return this.repository.getCourierList(params);
  }

  public manualAssign(payload: ManualAssignRequest): Promise<ManualAssignResponse> {
    return this.repository.manualAssign(payload);
  }
}
